import { createSelector } from 'reselect'
import shouldShowFastTrackExpiryLoyaltySelect from 'modules/loyalty/redux/selectors/should-show-fast-track-expiry'
import shouldShowFastTrackExpiryBannerLoyaltySelectUtil from 'modules/loyalty/redux/selectors/should-show-fast-track-expiry-banner/utils'
import isInGiftingModeGiftSelect from 'modules/gift/redux/selectors/is-in-gifting-mode'
import isGiftOrSelfGiftingUrlLocationUtil from 'utils/location/is-gift-or-self-gifting'
import shouldShowModalOrBannerExpiringLoyaltyFastTrackUtil from 'containers/LoyaltyFastTrackExpiry/utils/should-show-modal-or-banner'
import isHomeUrlLocationUtil from 'utils/location/is-home-url'
import isMixedCollectionUrlLocationUtil from 'utils/location/is-mixed-collection-url'
import hasOngoingDealsAppSelect from 'modules/app/redux/selectors/has-ongoing-deals'
import shouldShowUnlockedExtraFreeSamplesBannerCartSelect from 'containers/UnlockedExtraFreeSamplesBanner/selectors/should-show'

const shouldShowFastTrackExpiryBannerLoyaltySelect = createSelector(
  shouldShowFastTrackExpiryLoyaltySelect,
  isInGiftingModeGiftSelect,
  hasOngoingDealsAppSelect,
  shouldShowUnlockedExtraFreeSamplesBannerCartSelect,
  (
    shouldShowFastTrackExpiry,
    isInGiftingMode,
    hasOngoingDeals,
    shouldShowUnlockedExtraFreeSamplesBanner
  ) => shouldShowFastTrackExpiryBannerLoyaltySelectUtil({
    shouldShowFastTrackExpiry,
    isInGiftingMode,
    isGiftOrSelfGiftingUrl: isGiftOrSelfGiftingUrlLocationUtil(),
    shouldShowFastTrackModalOrBannerExpiring: shouldShowModalOrBannerExpiringLoyaltyFastTrackUtil(),
    hasOngoingDeals,
    isMixedCollectionUrl: isMixedCollectionUrlLocationUtil(),
    isHomeUrl: isHomeUrlLocationUtil(),
    shouldShowUnlockedExtraFreeSamplesBanner
  })
)

export default shouldShowFastTrackExpiryBannerLoyaltySelect
